export default {
  // Gallery page hero
  "gallery.hero.breadcrumb_home": "Acasă",
  "gallery.hero.breadcrumb_gallery": "Galerie",
  "gallery.hero.title": "Galerie FOPMN",
  "gallery.hero.subtitle": "Videoclipuri și imagini autentice din activitatea zilnică a pescarilor profesioniști de la Marea Neagră.",
  "gallery.prev": "Anterior",
  "gallery.next": "Următor",
  "gallery.of": "din",

  // Media Showcase (video + photo gallery — pe pagina /galerie)
  "home.media.label": "Din teren",
  "home.media.title": "Pescarii FOPMN în acțiune",
  "home.media.description": "Alături de întreaga comunitate de pescari de la Marea Neagră, membrii federației noastre contribuie activ la menținerea și dezvoltarea pescuitului comercial românesc. Urmăriți imagini și secvențe video din activitatea lor zilnică: de la gestionarea responsabilă a uneltelor de pescuit, până la descărcarea capturilor în punctele de debarcare autorizate și comercializare.",
  "home.media.hint": "Apasă pe imagine/video pentru a le vedea mărite.",
  "home.media.prev": "Video anterior",
  "home.media.next": "Video următor",
  "home.media.close": "Închide",
  "home.media.video1": "Hamsie capturată la talian în Marea Neagră",
  "home.media.video2": "Pește capturat la talian",
  "home.media.video3": "Lansare traul pelagic în Marea Neagră",
  "home.media.video4": "Captură de rapană cu Beam Trawl",
  "home.media.video5": "Lansare Beam Traul la apă",
  "home.media.video6": "Captură record de rapană cu scafandri",
  "home.media.video7": "Rapana capturată cu scafandri",
  "home.media.video8": "Captură de midii de Marea Neagră",
  "home.media.video9": "Sortare și depozitare midii pe vas",
  "home.media.video10": "Denisipare și pregătire vânzare midii proaspete",
  "home.media.img1": "Captură record de pește la talian",
  "home.media.img2": "Pește proaspăt la bordul ambarcațiunii",
  "home.media.img3": "Captură de rapană cu scafandri",
  "home.media.img4": "Plecare traulere pe mare",
  "home.media.img5": "Captură mixtă lufar, stavrid, barbun",
  "home.media.img6": "Pește capturat cu traul pelagic",
  "home.media.img7": "Trauler acostat în port la Marea Neagră",
  "home.media.img8": "Trauler acostat în port — vedere laterală",
  "home.media.img9": "Pește prins cu traulul pelagic",
  "home.media.img10": "Selecție midii pe navă",
  "home.media.img11": "Selecție pește în CPV",
  "home.media.img12": "Recoltare rapane cu scafandri",
  "home.media.img13": "Midii de Marea Neagră — spălare și denisipare",
  "home.media.img14": "Midii proaspete spălate și denisipate",
  "home.media.img15": "Pregătire midii pentru vânzare",
  "home.media.img16": "Talian la Marea Neagră operat de membri FOPMN",
  "home.media.img17": "Hamsie de Marea Neagră — la talianul membrilor FOPMN",
  "home.media.img18": "La cusut plasa de pescuit (punga)",
  "home.media.img19": "Nave din flota FOPMN",
  "home.media.img20": "Fabrică de prelucrare și congelare pește",
  "home.media.img21": "Hamsie capturată la talian în Marea Neagră",
};